import type { SVGProps } from 'react';

export const StarBurstIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="currentColor"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      d="M41.992 37.2L37.2115 32.4L38.792 30.8195L43.592 35.6L41.992 37.2ZM35.196 13.5655L33.6155 11.9845L38.396 7.204L39.996 8.7845L35.196 13.5655ZM12.396 13.5845L7.6155 8.7845L9.196 7.204L13.996 11.9845L12.396 13.5845ZM5.5805 37.2L4 35.6L8.7805 30.8195L10.3805 32.4L5.5805 37.2ZM15.4845 37.25L23.796 32.2615L32.127 37.3195L29.9305 27.881L37.2345 21.554L27.596 20.696L23.796 11.8155L20.015 20.646L10.3765 21.4845L17.6805 27.85L15.4845 37.25ZM12.0615 42L15.1575 28.7L4.796 19.731L18.4655 18.5575L23.796 6L29.146 18.5575L42.815 19.731L32.4535 28.7L35.55 42L23.796 34.9345L12.0615 42Z"
      fill="currentColor"
    />
  </svg>
);
